<template>
    <div>
        <b-row wrap>
            <b-col cols="12" md="3">
                <app-column-chart
                    title="Peatonales"
                    :chart-data="pedestrian"
                    :show-data-table="false"
                    :small="true"
                    :show-legends="false"
                ></app-column-chart>
            </b-col>
            <b-col cols="12" md="3">
                <app-column-chart
                    title="Vehiculares"
                    :chart-data="vehicular"
                    :show-data-table="false"
                    :small="true"
                    :show-legends="false"
                ></app-column-chart>
            </b-col>
            <b-col cols="12" md="3">
                <app-column-chart
                    title="Minutas"
                    :chart-data="annotations"
                    :show-data-table="false"
                    :small="true"
                    :show-legends="false"
                ></app-column-chart>
            </b-col>
            <b-col cols="12" md="3">
                <app-column-chart
                    title="Correspondencia"
                    :chart-data="mails"
                    :show-data-table="false"
                    :small="true"
                    :show-legends="false"
                ></app-column-chart>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import ColumnChart from '../../../../Reporting/Charts/ColumnChart';
export default {
    name: 'operational_charts',
    components: {
        appColumnChart: ColumnChart
    },
    props: ['pedestrian', 'vehicular', 'annotations', 'mails']
}
</script>